module.exports = __webpack_public_path__ + "img/image1.cb45d9c3.png";